import { render, staticRenderFns } from "./relevance.vue?vue&type=template&id=547448d1&scoped=true"
import script from "./relevance.vue?vue&type=script&lang=js"
export * from "./relevance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547448d1",
  null
  
)

export default component.exports